
export default {
  name: 'ShoppingCartCheckout',
  props: {
    items: {
      type: Array,
      default: () => []
    },
    checkoutLink: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    canCheckout() {
      return this.items.length
    }
  },
  methods: {
    checkout() {
      if (this.checkoutLink) {
        if (this.$route.path == this.$pagePath('checkout')) {
          this.$drawer.close('shopping-cart')
        } else {
          this.$navigateTo('checkout')
        }
      } else {
        this.$emit('checkout')
      }
    },
    continueShopping() {
      if (this.$route.path == this.$cart.continuePath) {
        this.$drawer.close('shopping-cart')
      } else {
        this.$cart.continueShopping()
      }
    }
  }
}
